<template>
  <div class="skin-success-screen">
    <div class="fireworks" aria-hidden="true">
      <div v-for="n in 8" :key="n" :class="`firework firework--${n}`"></div>
    </div>
    <div class="skin-success-card">
      <div class="skin-success-image-wrap">
        <img
          v-if="imageUrl"
          :src="imageUrl"
          class="skin-success-image"
          alt="Skin preview"
        />
        <div v-else class="skin-success-image-placeholder">🎨</div>
      </div>
      <h2 class="skin-success-title">{{ title }}</h2>
      <p class="skin-success-name" v-if="skinName">{{ skinName }}</p>
      <p class="skin-success-sub">{{ subtitle }}</p>
      <button class="skin-success-btn" @click="$emit('action')">{{ actionLabel }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkinSuccessScreen',
  props: {
    imageUrl:    { type: String,  default: null },
    skinName:    { type: String,  default: null },
    title:       { type: String,  default: 'Done!' },
    subtitle:    { type: String,  default: '' },
    actionLabel: { type: String,  default: 'OK' },
  },
  emits: ['action'],
};
</script>

<style scoped>
.skin-success-screen {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 480px;
  overflow: hidden;
}

.skin-success-card {
  position: relative;
  z-index: 2;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border: 1px solid #475569;
  border-radius: 24px;
  padding: 40px 48px;
  text-align: center;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
  max-width: 480px;
  width: 100%;
}

.skin-success-image-wrap {
  margin: 0 auto 24px;
  width: 200px;
  height: 200px;
  border-radius: 16px;
  overflow: hidden;
  background: #0f172a;
  border: 2px solid #334155;
}

.skin-success-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.skin-success-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4em;
}

.skin-success-title {
  color: #f1f5f9;
  font-size: 1.8em;
  margin: 0 0 8px;
}

.skin-success-name {
  color: #94a3b8;
  font-size: 1em;
  margin: 0 0 8px;
  font-style: italic;
}

.skin-success-sub {
  color: #64748b;
  font-size: 0.9em;
  margin: 0 0 28px;
}

.skin-success-btn {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px 36px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.skin-success-btn:hover {
  opacity: 0.88;
}

/* Fireworks */
.fireworks {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

.firework {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation: firework-burst 1.4s ease-out infinite;
}

.firework--1  { left: 12%; top: 15%; background: #f59e0b; animation-delay: 0s;    animation-duration: 1.3s; }
.firework--2  { left: 82%; top: 10%; background: #ec4899; animation-delay: 0.2s;  animation-duration: 1.5s; }
.firework--3  { left: 48%; top: 8%;  background: #34d399; animation-delay: 0.45s; animation-duration: 1.2s; }
.firework--4  { left: 70%; top: 30%; background: #60a5fa; animation-delay: 0.7s;  animation-duration: 1.6s; }
.firework--5  { left: 25%; top: 40%; background: #f87171; animation-delay: 0.15s; animation-duration: 1.4s; }
.firework--6  { left: 90%; top: 55%; background: #a78bfa; animation-delay: 0.55s; animation-duration: 1.3s; }
.firework--7  { left: 5%;  top: 60%; background: #fbbf24; animation-delay: 0.9s;  animation-duration: 1.5s; }
.firework--8  { left: 60%; top: 70%; background: #2dd4bf; animation-delay: 0.35s; animation-duration: 1.2s; }

@keyframes firework-burst {
  0%   { transform: scale(1) translateY(0);   opacity: 1; box-shadow: 0 0 0 0 currentColor; }
  40%  { transform: scale(1.4) translateY(-30px); opacity: 0.9; box-shadow: 0 0 0 20px transparent; }
  100% { transform: scale(0.2) translateY(-80px); opacity: 0; }
}
</style>
